<!--基本html代码区域-->
<template>
  <div class="firstdemo">
    <el-form ref="form" :model="form" label-width="100px">
      <el-row type="flex" justify="center">
        <el-col :span="5">
          <el-form-item label-width="70px">
            <span>
              <font color="pink" size="3">注册登录页面</font>
            </span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
        <el-col :span="5">
          <el-form-item label="账户：" prop="name">
            <el-input v-model="form.mobile" size="small"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
        <el-col :span="5">
          <el-form-item label="密码：" prop="password">
            <el-input v-model="form.password" size="small"></el-input>
          </el-form-item>
          <el-form-item label="员工号" prop="password">
            <el-input v-model="form.empno" size="small"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
        <el-col :span="5">
          <el-form-item>
            <el-button type="primary" @click="submit">登录</el-button>
            <el-button @click="register">注册</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
// import { login } from "../api/login";
import { service } from "../utils/request";
import store from "../store";

// export function login(data) {
//   return service({
//     url: "api/index/login",
//     method: "post",
//     data: data,
//   });
// }
export default {
  name: "firstdemo",
  data() {
    return {
      form: {
        empno: "",
        mobile: "",
        password: "",
        type: "1",
        verification_code: "",
      },
    };
  },
  methods: {
    /*提交进行判断的函数 */
    async submit() {
      const { code, data } = await service({
        url: "api/index/login",
        method: "post",
        data: this.form,
      });
      if (code == 1) {
        console.log(data);
        localStorage.setItem("app_id", data.app_id);
        localStorage.setItem("token", data.app_token);
        store.commit("SET_TOKEN", data.app_token);
        store.commit("SET_APPID", data.app_id);
        this.$router.replace("/apply/newVip/13/home/vipIndex");
      }
    },
    register: function() {},
  },
};
</script>

<!-- 写样式的地方 -->
<style scoped></style>
